
import React from "react";
import { base44 } from "@/api/base44Client";
import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { FileText, AlertCircle, Download } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function StudentGuidelines() {
  const { data: contentItems = [], isLoading } = useQuery({
    queryKey: ['content'],
    queryFn: () => base44.entities.Content.list(),
  });

  const guidelines = contentItems.find(c => c.content_key === 'ea_asd_guidelines');

  if (isLoading) {
    return (
      <div className="p-4 md:p-8 bg-gradient-to-br from-slate-50 to-blue-50 min-h-screen">
        <div className="max-w-5xl mx-auto">
          <p className="text-center text-slate-500">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-8 bg-gradient-to-br from-slate-50 to-blue-50 min-h-screen">
      <div className="max-w-5xl mx-auto space-y-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
            <FileText className="w-6 h-6 text-red-700" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-slate-900">EA/ASD Guidelines</h1>
            <p className="text-slate-600 mt-1">Eagle Academy and After School Detention Guidelines</p>
          </div>
        </div>

        {!guidelines || !guidelines.file_url ? (
          <Alert className="bg-orange-50 border-orange-200">
            <AlertCircle className="w-4 h-4 text-orange-700" />
            <AlertDescription className="text-orange-900">
              <strong>No guidelines available yet.</strong> Your administrator will upload the EA/ASD guidelines soon.
            </AlertDescription>
          </Alert>
        ) : (
          <Card className="border-none shadow-lg">
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle>EA/ASD Guidelines Document</CardTitle>
                <a href={guidelines.file_url} download target="_blank" rel="noopener noreferrer">
                  <Button className="bg-red-700 hover:bg-red-800">
                    <Download className="w-4 h-4 mr-2" />
                    Download
                  </Button>
                </a>
              </div>
            </CardHeader>
            <CardContent>
              {guidelines.file_type === 'pdf' ? (
                <div className="w-full h-[800px] border border-slate-200 rounded-lg overflow-hidden">
                  <iframe
                    src={guidelines.file_url}
                    className="w-full h-full"
                    title="EA/ASD Guidelines"
                  />
                </div>
              ) : (
                <div className="w-full flex justify-center">
                  <img 
                    src={guidelines.file_url} 
                    alt="EA/ASD Guidelines"
                    className="max-w-full h-auto rounded-lg shadow-md"
                  />
                </div>
              )}
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
